import { useState } from 'react';

import {
  FaCaretDown,
  FaCaretUp,
  FaSort,
} from 'react-icons/fa';

import CopyButton from './CopyButton';

import '../css/DriverTable.css';

export default function DriverList({
  drivers, click
}) {

  const intSortKeys = ['d_driver', 'd_company', 'd_id'];
  const stringSortKeys = ['d_driverName', 'd_status', 'd_configfile', 'd_deviceName', 'd_type'];
  const timestampSortKeys = ['d_timestamp'];
  const versionSortKeys = ['d_version', 'd_osVersion'];

  const [sortBy, setSortBy] = useState('d_timestamp');
  const [sortAsc, setSortAsc] = useState(false);

  const driverList = drivers.sort((a, b) => {
    
    if (intSortKeys.includes(sortBy)){
      return sortByNumber(a, b);
    } else if (stringSortKeys.includes(sortBy)) {
      return sortByString(a, b);
    } else if (timestampSortKeys.includes(sortBy)) { //TODO: not working?
      return sortByTimestamp(a, b);
    } else if (versionSortKeys.includes(sortBy)) {
      return sortByVersion(a, b);
    } else if (sortBy.length === 0){
      // No sorting defined - do nothing
    } else {
      console.log(`Unknown column: ${sortBy}`);
    }

    return 0;

  });

  const driverRows = driverList.map(d => <DriverRow driver={d} key={d.d_id} click={click} />);

  function sortDrivers(by) {
    if (sortBy === by) {
      setSortAsc(!sortAsc);
    } else {
      setSortAsc(false);
    }

    setSortBy(by);
  }

  function sortByVersion(a, b) {
    a = a[sortBy];
    b = b[sortBy];
    if (a === b) return 0;

    var v1 = a.replace(/[^0-9.]/g, '').split('.');
    var v2 = b.replace(/[^0-9.]/g, '').split('.');

    var maxLength = v1.length > v2.length ? v1.length : v2.length;

    var aBigger = true;
    for (var i = 0; i < maxLength; i++) {
      var a2 = i < v1.length ? parseInt(v1[i]) : 0;
      var b2 = i < v2.length ? parseInt(v2[i]) : 0;

      if (b2 > a2) {
        aBigger = false;
        break;
      } else if (b2 === a2) {
        continue;
      } else {
        break;
      }
    }

    // hijack results
    if (a.length === 0) {
      aBigger = false;
    } else if (b.length === 0) {
      aBigger = true;
    }

    if (sortAsc)
      return aBigger ? 1 : -1;
    else
      return aBigger ? -1 : 1;
  }

  function sortByTimestamp(a, b) {
    var d1 = new Date(a[sortBy]);
    var d2 = new Date(b[sortBy]);
    if (sortAsc)
      return d1 - d2;
    else
      return d2 - d1;
  }

  function sortByString(a, b) {
    if (a[sortBy] === null) a[sortBy] = '';
    if (b[sortBy] === null) b[sortBy] = '';
    if (sortAsc)
      return a[sortBy].localeCompare(b[sortBy]);
    else
      return b[sortBy].localeCompare(a[sortBy]);
  }

  function sortByNumber(a, b) {
    if (a[sortBy] === null) a[sortBy] = 0;
    if (b[sortBy] === null) b[sortBy] = 0;
    if (sortAsc)
      return a[sortBy] - b[sortBy];
    else
      return b[sortBy] - a[sortBy];
  }

  const sortDriversById = () => sortDrivers('d_id');
  const sortDriversByNumber = () => sortDrivers('d_driver');
  const sortDriversByName = () => sortDrivers('d_driverName');
  const sortDriversByStatus = () => sortDrivers('d_status');
  const sortDriversByConfig = () => sortDrivers('d_configfile');
  const sortDriversByDevice = () => sortDrivers('d_deviceName');
  const sortDriversByType = () => sortDrivers('d_type');
  const sortDriversByCompany = () => sortDrivers('d_company');
  const sortDriversByTimestamp = () => sortDrivers('d_timestamp');
  const sortDriversByAppVersion = () => sortDrivers('d_version');
  const sortDriversByOsVersion = () => sortDrivers('d_osVersion');

  return (
  	<table className="table table-hover">
      <thead>
        <tr>
          <TableHeading onClick={sortDriversById} className="thSort" sort={sortBy === 'd_id' ? sortAsc : undefined}>
            ID
          </TableHeading>
          <TableHeading onClick={sortDriversByNumber} className="thSort" sort={sortBy === 'd_driver' ? sortAsc : undefined}>
            Drv
          </TableHeading>
          <TableHeading onClick={sortDriversByName} className="thSort hide-on-med-and-down" sort={sortBy === 'd_driverName' ? sortAsc : undefined}>
            Name
          </TableHeading>
          <TableHeading onClick={sortDriversByStatus} className="thSort" sort={sortBy === 'd_status' ? sortAsc : undefined}>
            Status
          </TableHeading>
          <TableHeading onClick={sortDriversByConfig} className="thSort hide-on-small-and-down" sort={sortBy === 'd_configfile' ? sortAsc : undefined}>
            Config
          </TableHeading>
          <TableHeading onClick={sortDriversByDevice} className="thSort hide-on-small-and-down" sort={sortBy === 'd_deviceName' ? sortAsc : undefined}>
            Device
          </TableHeading>
          <TableHeading onClick={sortDriversByType} className="thSort hide-on-med-and-down" sort={sortBy === 'd_type' ? sortAsc : undefined}>
            Type
          </TableHeading>
          <TableHeading onClick={sortDriversByCompany} className="thSort hide-on-med-and-down" sort={sortBy === 'd_company' ? sortAsc : undefined}>
            Company ID
          </TableHeading>
          <TableHeading onClick={sortDriversByTimestamp} className="thSort hide-on-small-and-down" sort={sortBy === 'd_timestamp' ? sortAsc : undefined}>
            Timestamp
          </TableHeading>
          <TableHeading onClick={sortDriversByAppVersion} className="thSort hide-on-small-and-down" sort={sortBy === 'd_version' ? sortAsc : undefined}>
            App
          </TableHeading>
          <TableHeading onClick={sortDriversByOsVersion} className="thSort hide-on-small-and-down" sort={sortBy === 'd_osVersion' ? sortAsc : undefined}>
            OS
          </TableHeading>
        </tr>
      </thead>
      <tbody>
        {driverRows}
      </tbody>
    </table>
  );

}

function DriverRow({
  driver: d,
  click,
}){

	function getDriverId(d) {
		if (d.d_type === 'HubMobile' || d.d_type === 'HubDespatch iOS' || d.d_type === 'HubWarehouse iOS') {
			return 'IOS' + d.d_id.toString().padStart(6, '0');
		} else if (d.d_type === 'HubMobileAndroid' || d.d_type === 'HubDespatch Android' || d.d_type === 'HubWarehouse Android') {
			return 'AND' + d.d_id.toString().padStart(6, '0');
		} else {
			return d.d_id.toString();
		}
	}

	function rowClick(){
		click(d);
	}

    return (
        <tr key={d.d_id} onClick={rowClick} className="DriverRow">
          <td>
            <div className="driverId">
              <span>{ getDriverId(d) }</span>
              <CopyButton value={getDriverId(d)} />
            </div>
          </td>
          <td>{ d.d_driver }</td>
          <td className="hide-on-med-and-down">{ d.d_driverName }</td>
          <td>{ d.d_status }</td>
          <td className="hide-on-small-and-down">{ d.d_configfile }</td>
          <td className="hide-on-small-and-down">{ d.d_deviceName }</td>
          <td className="hide-on-med-and-down">{ d.d_type }</td>
          <td className="hide-on-med-and-down">{ d.d_company }</td>
          <td className="hide-on-small-and-down">{ d.d_timestamp }</td>
          <td className="hide-on-small-and-down">{ d.d_version }</td>
          <td className="hide-on-small-and-down">{ d.d_osVersion }</td>
        </tr>
    )
}

function TableHeading({
  onClick,
  className,
  sort, // boolean | undefined
  children,
}) {
  return <th
    onClick={onClick}
    className={`TableHeading ${className}`}
  >
    <div>
      <span>{children}</span>
      {sort
        ? <FaCaretUp />
        : sort === undefined
          ? <FaSort />
          : <FaCaretDown />}
    </div>
  </th>
}
